import { Injectable } from "@angular/core";
import { Result } from "src/app/beans/result/result.bean";
import { Service } from "src/app/beans/service/service.bean";
import { SlotModelAuto } from "src/app/beans/slot-model/slot-model.auto.bean";
import { SlotModel } from "src/app/beans/slot-model/slot-model.bean";
import { SlotModelDay } from "src/app/beans/slot-model/slot-model.day.bean";
import { SlotModelDetails } from "src/app/beans/slot-model/slot-model.details.bean";
import { NotifierMessage } from "src/app/enums/notifier/message/notifier.enum";
import { Notifier } from "src/app/enums/notifier/notifier.enum";
import { ErrorManager } from "src/app/managers/error/error.manager";
import { NotifierManager } from "src/app/managers/notifier/notifier.manager";
import { RequestManager } from "src/app/managers/request/request.manager";
import { UtilsManager } from "src/app/managers/utils/utils.manager";




@Injectable
({
  providedIn: 'root'
})

export class SlotModelHandler
{
    constructor
    (

      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager    ,

    ) {}


    //-----------------------------------------------------------------------------------------
    async listAuto( token: string, siteId: number)
    {    
      this.validateToken(token);
      this.validateSiteId(siteId);

      try
      {
        const response = await this._request.slotModel().listAuto( token, siteId).toPromise()

        if ( this._error.hasError( response ) )
        {
          // MANAGE ERROR
          return this._error.handleCQWebapp ( response ) 
        }

        return response as SlotModelAuto[]

      }catch( error )
      {
        // this._error.handleNetwork ( error )  
        return undefined
      }
    }

    //-----------------------------------------------------------------------------------------
    async list ( token: string, siteId: number)
    {
      this.validateToken(token);
      this.validateSiteId(siteId);

      try
      {
        const response = await this._request.slotModel().list( token, siteId).toPromise()

        if ( this._error.hasError( response ) )
        {
          // MANAGE ERROR
          return this._error.handleCQWebapp ( response ) 
        }

        return response as SlotModel[]

      }catch( error )
      {
        // this._error.handleNetwork ( error )  
        return undefined
      }      

    }

    //-----------------------------------------------------------------------------------------
    async detail(token: string, modelId: number)
    {
      this.validateToken(token);

      try
      {
        const response = await this._request.slotModel().detail( token, modelId).toPromise()        

        if ( this._error.hasError( response ) )
        {
          // MANAGE ERROR
          return this._error.handleCQWebapp ( response ) 
        }
        

        return response as SlotModel

      }catch( error )
      {
        // this._error.handleNetwork ( error )  
        return undefined
      }     
    }



     //-----------------------------------------------------------------------------------------
     async create(token: string, model: SlotModel)
     {
       this.validateToken(token);
 
       try
       {
         const response = await this._request.slotModel().create( token, model).toPromise()        
         
         if ( this._error.hasError( response ) )
         {
           // MANAGE ERROR
           return this._error.handleCQWebapp ( response ) 
         }
         else
         {
           this._notifier.show
             ( 
               Notifier.SUCCESS            , 
               NotifierMessage.OPERATION_OK
             )
             return response as Result
         }  
         
       }catch( error )
       {
         // this._error.handleNetwork ( error )  
         return undefined
       } 
     }

    //-----------------------------------------------------------------------------------------
    async update(token: string, model: SlotModel)
    {
      this.validateToken(token);

      try
      {
        const response = await this._request.slotModel().update( token, model).toPromise()        
        
        if ( this._error.hasError( response ) )
        {
          // MANAGE ERROR
          return this._error.handleCQWebapp ( response ) 
        }
        else
        {
          this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response as Result
        }  
        
      }catch( error )
      {
        // this._error.handleNetwork ( error )  
        return undefined
      } 
    }

    //-----------------------------------------------------------------------------------------
    async manageSlot(token: string, model: number, day: SlotModelDay)
    {
      this.validateToken(token);

      try
      {
        const response = await this._request.slotModel().manageSlot( token, model, day).toPromise()        

        if ( this._error.hasError( response ) )
        {
          // MANAGE ERROR
          return this._error.handleCQWebapp ( response ) 
        }
        

        return response as SlotModel

      }catch( error )
      {
        // this._error.handleNetwork ( error )  
        return undefined
      }     
    }

    //-----------------------------------------------------------------------------------------
    async automate (token: string, slotModelAuto: SlotModelAuto)
    {
      this.validateToken(token);

      try
      {
        const response = await this._request.slotModel().automate( token, slotModelAuto).toPromise()

        if ( this._error.hasError( response ) )
        {
          // MANAGE ERROR
          return this._error.handleCQWebapp ( response ) 
        }
        else
        {
          this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response as Result
        }

      }catch( error )
      {
        // this._error.handleNetwork ( error )  
        return undefined
      }      

    }

    //-----------------------------------------------------------------------------------------
    async apply (token: string, dF: string, dT: string, s: number, m: number, h: number, d: number)
    {
      this.validateToken(token);

      try
      {
        const response = await this._request.slotModel().apply( token, dF, dT, s, m, h, d).toPromise()

        if ( this._error.hasError( response ) )
        {
          // MANAGE ERROR
          return this._error.handleCQWebapp ( response ) 
        }
        else
        {
          this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response as Result
        }

      }catch( error )
      {
        // this._error.handleNetwork ( error )  
        return undefined
      }      

    }

    //-----------------------------------------------------------------------------------------
    validateToken(token: string)
    {
      if ( !this._utils.checker().isValidText( token ) ) 
      {
        this._notifier.show
        ( 
          Notifier.WARNING, 
          NotifierMessage.INVALID_PASSWORD
        )
        return undefined
      } 
    }
    
    //-----------------------------------------------------------------------------------------
    validateSiteId(siteId: number)
    {
      if ( !this._utils.checker().isValidId( siteId ) )
      {
        this._notifier.show
        ( 
          Notifier.WARNING, 
          NotifierMessage.INVALID_SITE_ID
        )
        return undefined
      }
    }

}